import { Divider, Grid, Typography } from '@material-ui/core';
import { bloqueioTipoOptions } from 'common/genericOptions';
import { BloqueioTipo } from 'common/genericTypes';
import { Button, Dropdown, LgSpace, MdSpace } from 'm2m.components';
import React, { useEffect, useState } from 'react';
import CadastroBloqueioPorConstricao from './constricao';
import CadastroBloqueioPorGarantia from './garantia';

const CadastrarBloqueio: React.FC = () => {
  const [bloqueioTipo, setBloqueioTipo] = useState<BloqueioTipo | null>(null);
  const [selectingForm, setSelectingForm] = useState<boolean>(true);
  const [bloqueioForm, setBloqueioForm] = useState<React.ReactNode>(null);

  useEffect(() => {
    switch (bloqueioTipo) {
      case BloqueioTipo.Garantia:
        setBloqueioForm(<CadastroBloqueioPorGarantia />);
        break;
      case BloqueioTipo.Constricao:
        setBloqueioForm(<CadastroBloqueioPorConstricao />);
        break;
      default:
        setBloqueioForm(null);
        break;
    }
  }, [bloqueioTipo, setBloqueioForm]);

  return (
    <div style={{ marginRight: 40 }}>
      <Typography variant="h1">{'Bloqueio'}</Typography>
      <LgSpace />
      <Divider variant="fullWidth" />
      {selectingForm || !bloqueioForm ? (
        <>
          <MdSpace />
          <Grid container justify="center">
            <Grid item md={4}>
              <Typography variant="h3" align="center">
                {'Antes de começar, nos informe o tipo de bloqueio a ser cadastrado:'}
              </Typography>
              <MdSpace />
              <Dropdown
                label="Tipo de Bloqueio"
                value={(bloqueioTipo ?? '') as string}
                onChange={(value) => setBloqueioTipo(value !== '' ? (value as BloqueioTipo) : null)}
                options={bloqueioTipoOptions}
                required
              />
              <MdSpace />
            </Grid>
          </Grid>
          <Grid container justify="center">
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setSelectingForm(false)}
                disabled={!bloqueioForm}
              >
                {'Prosseguir'}
              </Button>
              <MdSpace />
            </Grid>
          </Grid>
        </>
      ) : (
        bloqueioForm
      )}
    </div>
  );
};

export default CadastrarBloqueio;
